import React from "react";
import { Animated } from "react-animated-css";
import { FaCheckCircle, FaCheck } from "react-icons/fa";
const Checkmark = ({ className, style, isUnselected }) => {
  return (
    // <Animated animationIn={"bounceIn"}>
    <div
      className={className}
      style={{
        borderRadius: "100px",
        border: `2px solid var(${isUnselected ? "--light-grey" : "--green"})`,
        fontSize: "0.4em",
        padding: "0.4em",
        backgroundColor: "white",
        color: "var(--green)",
        boxShadow: "rgba(0,0,0,0.4) 0px 4px 50px",
        ...style,
      }}
    >
      {!isUnselected && <FaCheck />}
    </div>
    // </Animated>
  );
};
export default Checkmark;
